import React, { useState, useEffect } from "react";
import { Image } from "semantic-ui-react";
import Draggable from "react-draggable";

const DocUploadStatusModal = ({ documents, onClose }) => {
  const [docStatus, setdocStatus] = useState([]);
  const [isColapseClicked, setIsColapseClicked] = useState(true);

  useEffect(() => {
    setdocStatus(documents);
  }, [documents]);

  const handleClose = () => {
    onClose();
  };

  const handleColapse = () => {
    setIsColapseClicked(!isColapseClicked);
  };

  return (
    <Draggable cancel=".closeArrow">
      <div className="uploadingBox" style={styles.container}>
        <div className="uploadingBoxHead" style={styles.section}>
          <div className="flexAli">
            <Image src="/images/uploadFile.svg" alt="Upload" />
            <p>Uploading</p>
          </div>
          <div className="flexAli closeArrow">
            <div
              onClick={handleColapse}
              style={{ cursor: "pointer" }}
              data-cy="colapse-icon-cy"
            >
              {isColapseClicked ? (
                <Image src="/images/grey-chevron.svg" alt="Upload" />
              ) : (
                <Image src="/images/grey-up-icon.svg" alt="Upload" />
              )}
            </div>
            <div onClick={handleClose} data-cy="close-icon-cy">
              <Image
                src="/images/upload-black-close.svg"
                alt="collapse"
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
        <div className="uploading-outer-list-box">
        {isColapseClicked &&
          docStatus.map((item, index) => (
            <div key={index}>
              <div
                style={{
                  ...styles.section,
                  marginTop: "15px",
                  position: "relative",
                  padding: "5px 16px",
                }}
              >
                <div>
                  <p>
                    {item.documentName.length > 15
                      ? item.documentName.slice(0, 15) + "..."
                      : item.documentName}
                  </p>
                </div>
                <div className="uploadBlueLoader">
                  {item.status === 0 && (
                    <svg
                      version="1.1"
                      id="L9"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      enableBackground="new 0 0 0 0"
                      xmlSpace="preserve"
                      width="80px" // Set the width
                      height="80px" // Set the height
                      style={{
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        position: "absolute",
                        margin: "auto",
                      }}
                    >
                      <path
                        fill="#0053ed"
                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                      >
                        <animateTransform
                          attributeName="transform"
                          attributeType="XML"
                          type="rotate"
                          dur="1s"
                          from="0 50 50"
                          to="360 50 50"
                          repeatCount="indefinite"
                        />
                      </path>
                    </svg>
                  )}

                  {item.status === 1 && (
                    <Image
                      src="/images/upload-green-tick.svg"
                      alt="Upload"
                      data-cy="upload-green-tick"
                    />
                  )}

                  {item.status === 2 && (
                    <Image
                      src="/images/upload-error.svg"
                      alt="Upload"
                      data-cy="upload-error-tick"
                    />
                  )}
                </div>
              </div>
              {item.error && (
                <div className="uploadingErrorBox" style={styles.subSection}>
                  <p>{item.error}</p>
                </div>
              )}
            </div>
            
          ))}
        </div>
      </div>
    </Draggable>
  );
};

const styles = {
  container: {
    position: "absolute",
    bottom: "90px",
    right: "25px",
    background: "#ffffff",
    width: "250px",
    padding: "5px",
    zIndex: "1",
  },
  section: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px",
  },
  subSection: {
    marginLeft: "6px",
    marginTop: "15px",
    background: "#FFEBEE",
    borderRadius: "10px",
    padding: "5px",
  },
};

export default DocUploadStatusModal;
